import { Tabs } from '@mui/material';
import { useContext } from 'react';
import { Trans } from 'react-i18next';

import { AppContext } from '../../app/context';
import { TTab } from '../../app/router/tabs';
import { environment } from '../../environment';

import LinkTab from './link-tab';

interface IProps {
  selectedTab: TTab;
  selectTab: (tab: TTab) => void;
}

function TabBar({ selectedTab, selectTab }: IProps): React.JSX.Element {
  const {
    zone: { current: currentZone },
  } = useContext(AppContext);

  let route = '';
  if (currentZone?.administrativeLevel === 'world') route = `/`;
  else if (currentZone?.administrativeLevel === 'country') route = `/${currentZone.countryCode}/`;
  else if (currentZone?.administrativeLevel === 'region')
    route = `/${currentZone.countryCode}/${encodeURIComponent(currentZone.name)}/`;
  else if (currentZone) route = `/${currentZone.countryCode}/${currentZone.code}/`;

  return (
    <Tabs
      indicatorColor="primary"
      onChange={(_, value) => selectTab(value)}
      value={selectedTab}
      variant="fullWidth"
    >
      <LinkTab
        label={<Trans i18nKey="bicycle_facilities.navigation.stats" />}
        sx={{ textTransform: 'none', minWidth: 72 }}
        to={`${route}stats`}
        value="stats"
      />
      <LinkTab
        label={<Trans i18nKey="bicycle_facilities.navigation.contributions" />}
        sx={{ textTransform: 'none', minWidth: 72 }}
        to={`${route}contributions`}
        value="contributions"
      />
      {environment.config.enableCounts && (
        <LinkTab
          label={<Trans i18nKey="bicycle_facilities.navigation.counts" />}
          sx={{ textTransform: 'none', minWidth: 72 }}
          to={`${route}comptages`}
          value="comptages"
        />
      )}
    </Tabs>
  );
}

export default TabBar;
